import { authHeaders } from './_auth';

export function canManuallyDelete(role) {
  const normalized = String(role || '').trim().toLowerCase();
  return Boolean(normalized) && normalized !== 'finance';
}

export async function manualDelete(url) {
  const res = await fetch(url, {
    method: 'DELETE',
    credentials: 'include',
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  if (res.ok) return;

  let payload = null;
  try { payload = await res.json(); } catch (_) {}
  const message = Array.isArray(payload?.errors) ? payload.errors.join('\n') : payload?.error;
  throw new Error(message || `Gagal menghapus data (HTTP ${res.status}).`);
}
